import styled from 'styled-components';
import { WarningBanner } from 'ui/banner';
import { colors, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const FormContent = styled.div`
  background-color: ${colors.backgroundSecondary};
  border: thin solid ${colors.grey15};
  border-radius: ${spacing.quarter};
  padding: ${pxToRem(20)};
  display: flex;
  flex-direction: column;
`;

export const StyledWarningBanner = styled(WarningBanner)`
  margin-bottom: ${spacing.plusHalf};
`;
